var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-16-video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-16-video",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09090918,2 C1.38799718,2 0,3.388 0,5.09090909 L0,10.5454582 C0,12.2483673 1.38799718,13.6363673 3.09090918,13.6363673 L12.909091,13.6363673 C14.6120037,13.6363673 16,12.2483673 16,10.5454582 L16,5.09090909 C16,3.388 14.6120035,2 12.909091,2 L3.09090918,2 L3.09090918,2 Z M3.09090918,3.09090909 L12.909091,3.09090909 C14.026509,3.09090909 14.9090914,3.97349091 14.9090914,5.09090909 L14.9090914,10.5454582 C14.9090914,11.6628764 14.026509,12.5454582 12.909091,12.5454582 L3.09090918,12.5454582 C1.973491,12.5454582 1.09090918,11.6628764 1.09090918,10.5454582 L1.09090918,5.09090909 C1.09090918,3.97349091 1.973491,3.09090909 3.09090918,3.09090909 L3.09090918,3.09090909 Z M6.72727282,5.45454545 L6.72727282,10.1818218 L10.7272728,7.81818545 L6.72727282,5.45454545 Z",
    id: "Shape-Copy",
    fill: "#DDDDDD",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.714369dc6f0ad85f1bcf8c426e771c1b.svg";
export { ForwardRef as ReactComponent };